module.exports = __webpack_public_path__ + "static/media/ic-drawer-settings.59df95e7.svg";